import React from 'react'
import '../style/reservePop.scss'
import { CSSTransition } from 'react-transition-group'
import { util } from '../config'
import axios from 'axios'
import qs from 'qs'
class ReservePop extends React.Component {
  constructor(props) {
    super();
    this.state = {
      isVerifyShow: false,
      reserveInfo: {
        phone: "",
        code: "",
        system: ""
      },
      isCodeSend: false,
      isReserveSend: false,
      countDown: 0,
      step: 1,
      titleStyle: 0
    }
  }

  verify = null;
  timer = null;

  handleReserveInfoChange = (e) => {
    const target = e.currentTarget;
    const type = target.dataset.type;
    const name = target.dataset.name;
    const system = target.dataset.system;
    if (type === 'input') {
      const reserveInfo = Object.assign(this.state.reserveInfo, { [name]: target.value })
      this.setState({
        reserveInfo
      })
    } else if (type === 'option') {
      const reserveInfo = Object.assign(this.state.reserveInfo, { system })
      this.setState({
        reserveInfo
      })
    }
  }

  doReserve = () => {
    if (this.state.isReserveSend) {
      return;
    }
    if (!this.state.reserveInfo.phone) {
      util.showToast({ msg: '请输入手机号' });
      return;
    }
    if (!this.state.reserveInfo.code) {
      util.showToast({ msg: '请输入验证码' });
      return;
    }
    if (!this.state.reserveInfo.system) {
      util.showToast({ msg: '请选择手机系统' });
      return;
    }
    this.setState({
      isReserveSend: true
    })
    axios.post('https://actblood.web.sdo.com/Api/2020/1012/YuYue.ashx', qs.stringify({
      source: '20200917_' + this.state.reserveInfo.system,       //来源(可为空,不统计)
      phone: this.state.reserveInfo.phone,       //手机号
      code: this.state.reserveInfo.code,        // 短信验证码(6位数字)
      invite_code: this.props.invitedCode ? this.props.invitedCode : ''
    })).then(res => {
      this.setState({
        isReserveSend: false,
        reserveInfo: {
          phone: "",
          code: "",
          system: ""
        }
      })
      if (res.data.success) {
        const titleStyle = (res.data.msg === "-1005") ? 0 : 1;
        this.setState({
          step: 2, titleStyle
        });
        this.props.updateLoadInfo();
      } else {
        util.showToast({ msg: res.data.msg })
      }
    })
  }

  showVerify = () => {
    if (this.state.countDown !== 0) {
      return;
    }
    if (!this.state.reserveInfo.phone) {
      util.showToast({ msg: '请输入手机号' });
      return;
    }
    if (!this.verify) {
      this.verify = new window.Verify('20200917', '.reserve-pop .verify-container', this.handleVerifySuccess);
    }
    if (this.state.isCodeSend) {
      this.verify.retry();
    }
    this.setState({
      isVerifyShow: true,
      isCodeSend: true
    })
  }

  handleVerifySuccess = () => {
    this.setState({
      isVerifyShow: false
    });
    axios.post('https://actblood.web.sdo.com/Api/2020/1012/Send.ashx', qs.stringify({
      phone: this.state.reserveInfo.phone,
      appid: '20200917',
      vkey: this.verify.getCurrentKey()
    })).then(res => {
      if (res.data.success) {
        this.setState({ countDown: 60 });
        this.timer = setInterval(() => {
          const second = this.state.countDown - 1;
          this.setState({ countDown: second });
          if (second === 0) {
            clearInterval(this.timer);
          }
        }, 1000);
      } else {
        util.showToast({ msg: res.data.msg })
      }
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.phone !== this.props.phone && this.props.phone === "") {
      clearInterval(this.timer);
      this.setState({
        isVerifyShow: false,
        reserveInfo: {
          phone: "",
          code: "",
          system: ""
        },
        isReserveSend: false,
        countDown: 0,
        step: 1
      })
    }
  }

  render() {
    return (
      <div className='popup reserve-pop'>
        <div className="content">
          <div className="close" onClick={this.props.toggleReservePop}></div>
          <div className="fun-part" style={{ 'display': this.state.step === 1 ? 'block' : 'none' }}>
            <div className="inner">
              <div className="title"></div>
              <p className="tip">*已预约的小伙伴，请填写预约手机号进行登录，以参与邀请集结活动。</p>
              <div className="input-container">
                <div className="system-selection">
                  <div className={`ios ${this.state.reserveInfo.system === 'ios' ? 'active' : ''}`} data-type="option" data-system="ios" onClick={this.handleReserveInfoChange}>
                    <div className="option"></div><i></i><span>IOS</span>
                  </div>
                  <div className={`android ${this.state.reserveInfo.system === 'android' ? 'active' : ''}`} data-type="option" data-system="android" onClick={this.handleReserveInfoChange}>
                    <div className="option"></div><i></i><span></span>Android
                </div>
                </div>
                <input id="reserve-phone" data-type="input" data-name="phone" type="text" placeholder="请输入手机号" value={this.state.reserveInfo.phone} onChange={this.handleReserveInfoChange} />
                <input id="reserve-code" data-type="input" data-name="code" type="text" placeholder="短信验证码" value={this.state.reserveInfo.code} onChange={this.handleReserveInfoChange} />
                <div className="get-code" onClick={this.showVerify}>
                  {(this.state.countDown === 0) && <span>获取验证码</span>}
                  {!(this.state.countDown === 0) && <span>已发送（{this.state.countDown}s）</span>}
                </div>
                <CSSTransition in={this.state.isVerifyShow} timeout={500} classNames="fade">
                  <div className="verify-container"></div>
                </CSSTransition>
                <div className="confirm" onClick={this.doReserve}></div>
              </div>
            </div>
          </div>
          <div className="success-part" style={{ 'display': this.state.step === 2 ? 'block' : 'none' }}>
            <div className={`title ${this.state.titleStyle === 0 ? 'login-title' : 'reserve-title'}`}></div>
            <div className="inner">
              <p>邀请小伙伴们加入异世界之旅，领取<span>专属邀约好礼</span>吧！</p>
              <div className="invite-btn" onClick={this.props.goInvite}></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ReservePop;
